import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./client/style/style.css";
import Dashboard from "./admin/view/Dashboard";
import AdminCategory from "./admin/view/AdminCategory";
import AdminPackages from "./admin/view/AdminPackages";
import AddPackageType from "./admin/view/AddPackageType";
import EditPackageType from "./admin/view/EditPackageType";
import AddPackage from "./admin/view/AddPackage";
import UpdatePackage from "./admin/view/UpdatePackage";
import AdminBlog from "./admin/view/AdminBlog";
import AddBlog from "./admin/view/AddBlog";
import UpdateBlog from "./admin/view/UpdateBlog";
import AdminBanner from "./admin/view/AdminBanner";
import AddBanner from "./admin/view/AddBanner";
import Login from "./admin/view/auth/Login";
import PrivateRoute from "./admin/PrivateRoute";
import AddTheme from "./admin/view/AddTheme";
import AddDestination from "./admin/view/AddDestination";
import AdminTheme from "./admin/view/AdminTheme";
import AdminDestination from "./admin/view/AdminDestination";
import Home from "./client/pages/Home";
import Package from "./client/pages/Package";
import Blog from "./client/pages/Blog";
import Destination from "./client/pages/Destination";
import Theme from "./client/pages/Theme";
import BlogDetail from "./client/pages/BlogDetail";
import Contact from "./client/pages/Contact";
import PackageDetail from "./client/pages/PackageDetail";
import DestinationDetail from "./client/pages/DestinationDetail";
import ThemeDetails from "./client/pages/ThemeDetail";
import AddRelatedPackage from "./admin/view/AddRelatedPackage";
import AdminRelatedPackages from "./admin/view/AdminRelatedPackages";
import RelatedPackageDetail from "./client/pages/RelatedPackageDetail";
import UpdateTheme from "./admin/view/UpdateTheme";
import UpdateDestination from "./admin/view/UpdateDestination";
import UpdateRelatedPackage from "./admin/view/UpdateRelatedPackage";
import RelatedPackages from "./client/pages/RelatedPackages";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Client Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/packages/:id" element={<Package />} />
          <Route path="/packages/detail/:name" element={<PackageDetail />} />
          <Route path="/destination" element={<Destination />} />
          <Route path="/theme" element={<Theme />} />
          <Route path="/destination/:slug" element={<DestinationDetail />} />
          <Route path="/theme/:id" element={<ThemeDetails />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route
            path="/relatedpackage/:slug"
            element={<RelatedPackageDetail />}
          />
          <Route path="/relatedpackages" element={<RelatedPackages />} />

          <Route path="/contact" element={<Contact />} />

          {/* Admin Routes */}
          <Route element={<PrivateRoute />}>
            <Route exact path="/admin/dashboard" element={<Dashboard />} />
            <Route
              exact
              path="/admin/package_type"
              element={<AdminCategory />}
            />
            <Route
              exact
              path="/admin/package_type/:id"
              element={<EditPackageType />}
            />
            <Route
              exact
              path="/admin/add_package_type"
              element={<AddPackageType />}
            />
            <Route exact path="/admin/packages" element={<AdminPackages />} />
            <Route exact path="/admin/addpackages" element={<AddPackage />} />
            <Route
              exact
              path="/admin/packages/:slug"
              element={<UpdatePackage />}
            />
            <Route exact path="/admin/blogs" element={<AdminBlog />} />
            <Route exact path="/admin/addblogs" element={<AddBlog />} />
            <Route exact path="/admin/blogs/:slug" element={<UpdateBlog />} />
            <Route exact path="/admin/banner" element={<AdminBanner />} />
            <Route exact path="/admin/addbanner" element={<AddBanner />} />
            <Route exact path="/admin/themes" element={<AdminTheme />} />
            <Route exact path="/admin/addtheme" element={<AddTheme />} />
            <Route
              exact
              path="/admin/addrelatedpack"
              element={<AddRelatedPackage />}
            />
            <Route
              exact
              path="/admin/relatedpack"
              element={<AdminRelatedPackages />}
            />
            <Route
              exact
              path="/admin/edit-theme/:slug"
              element={<UpdateTheme />}
            />
            <Route
              exact
              path="/admin/edit-destination/:slug"
              element={<UpdateDestination />}
            />
            <Route
              exact
              path="/admin/edit-relatedpack/:slug"
              element={<UpdateRelatedPackage />}
            />

            <Route
              exact
              path="/admin/destinations"
              element={<AdminDestination />}
            />
            <Route
              exact
              path="/admin/adddestinations"
              element={<AddDestination />}
            />
          </Route>
          <Route exact path="/admin/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
